/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
export var ListSortDirection = /*@__PURE__*/ (function (ListSortDirection) {
    ListSortDirection[ListSortDirection["Ascending"] = 0] = "Ascending";
    ListSortDirection[ListSortDirection["Descending"] = 1] = "Descending";
    return ListSortDirection;
})({});
/**
 * @hidden
 */
export var ListSortDirection_$type = /*@__PURE__*/ markEnum('ListSortDirection', 'Ascending,0|Descending,1');
//# sourceMappingURL=ListSortDirection.js.map
